"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Blanket__Wrapper",
  componentId: "sc-1dz6qu3-0"
})(["position:relative;height:100%;width:100%;.gatsby-image-wrapper{bottom:0;left:0;position:absolute !important;right:0;top:0;img{object-fit:", ";}}"], function (_ref) {
  var contain = _ref.contain;
  return "".concat(contain ? 'contain' : 'cover', " !important");
});

var Background = function Background(_ref2) {
  var contain = _ref2.contain,
      rest = _objectWithoutProperties(_ref2, ["contain"]);

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    contain: contain
  }, /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], rest));
};

Background.defaultProps = {
  contain: false
};
Background.propTypes = {
  contain: _propTypes["default"].bool
};
var _default = Background;
exports["default"] = _default;